'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
import '@polymer/paper-tooltip/paper-tooltip'
import '@moskito/moskito-payment/moskito-payment'
import '@moskito/moskito-styles/moskito-styles'
Polymer({
  is: 'moskito-subscription',
  _template: html`
<style include="iron-flex iron-flex-alignment moskito-styles">
a {
  text-decoration: none;
  color: var(--default-primary-color);
}
paper-card.disabled{
  --paper-card: {
    border-left: 10px var(--paper-blue-grey-50) solid;
  }
}
paper-card.active {
  --paper-card: {
    border-left: 10px var(--paper-lime-a700) solid;
  }
}
.moskito-subscription-wrapper {
  align-items: center;
  min-width: 94px;
  max-width: 164px;
}
.subscription-name {
  text-align: center;
}
moskito-avatar.subscription-avatar {
  --paper-avatar-width: 28px;
  border: var(--default-secondary-color) solid 2px;
  margin-right: 12px;
}
div.v-center {
  display: flex;
  align-items: center;
}
.hidden {
display: none;
}
.warning {
  display: flex;
  align-items: center;
 margin: 12px;
background-color: var(--paper-red-a700);
color:
white;
padding: 12px;
font-weight: bold;
}
</style>
  <paper-card elevation="1" animated-shadow="false" class$="[[_getDisabledClass(subscription)]]">
    <div class="card-content layout vertical">
        <h4 class="flex-2 v-spaced">
          <span class="accent">{{subscription.subscription_type.name}}</span>
          &nbsp;({{subscription.subscription_type.description}})
        </h4>
      <div class="layout horizontal v-spaced">
        <div class="flex h-spaced">
          <span class="accent">
            {{_translate('Start Date') }}
          </span>
          {{_formatDate(subscription.start_date)}}
        </div>
        <div class="flex h-spaced">
          <span class="accent">
            {{_translate('End Date')}}
          </span>
          {{_formatDate(subscription.end_date)}}
        </div>
        <div class="flex h-spaced">
          <span class="accent">
            {{_translate('ID')}}
          </span>
          {{subscription.id}}
        </div>
      </div>
      <div><span class="accent v-spaced">{{_translate('Owner')}}</span> {{subscription.possessable.name}}</div>
      <template is="dom-if" if="{{subscription.current_user_pending}}">
        <div class="warning">
          <iron-icon icon="icons:warning"></iron-icon> Vous avez demandé à bénéficier de cette licence. Votre demande est en attente de traitement par son détenteur.
          <paper-button on-tap="_cancel"><iron-icon icon="icons:close"></iron-icon>{{_translate('Cancel')}}</paper-button>
       </div>
      </template>
      <template is="dom-if" if="{{subscription.can_edit}}">
        <div class="layout grid v-spaced">
          <h5 class="accent">{{_translate('Grantees')}}</h5>
          <template is="dom-repeat" items="{{subscription.grantees}}">
            <div class="flex v-center">
              <moskito-avatar id="grantee-{{item.id}}" src="{{item.avatar.miniature.url}}" label="{{item.fullname}}" two-chars class="subscription-avatar">
              </moskito-avatar> <span class="accent">{{item.fullname}}</span>&nbsp; <span>{{item.user.email}}</span>
              <paper-tooltip for="grantee-{{item.id}}">{{item.fullname}}</paper-tooltip>
              <paper-button data-id="{{item.id}}" on-tap="_deny" disabled$="[[_preventSelfDelete(item.id)]]"><iron-icon icon="icons:close"></iron-icon>{{_translate('Remove')}}</paper-button>
            </div>
          </template>
          <template is="dom-if" if="{{_anyPending()}}">
            <h5>{{_translate('Pending requests')}}</h5>
            <p>{{_translate('The following users have requested to benefit from this Subscription. Please review these requests and accept or deny them.')}}</p>
            <div class="layout vertical">
            <template is="dom-repeat" items="{{subscription.pending_grantees}}">
              <div class="flex v-center">
                <moskito-avatar id="grantee-{{item.id}}" src="{{item.avatar.miniature.url}}" label="{{item.fullname}}" two-chars class="subscription-avatar">
                </moskito-avatar> <span class="accent">{{item.fullname}}</span>&nbsp; <span>{{item.user.email}}</span>
                <paper-tooltip for="grantee-{{item.id}}">{{item.fullname}}</paper-tooltip>
                <paper-button data-id="{{item.id}}" on-tap="_deny"><iron-icon icon="icons:close"></iron-icon>{{_translate('Deny')}}</paper-button>
                <paper-button data-id="{{item.id}}" on-tap="_accept"><iron-icon icon="icons:check"></iron-icon>{{_translate('Accept')}}</paper-button>
              </div>
            </template>
            </div>
          </template>
        </div>
      </template>
    </div>
  </paper-card>
`,
  properties: {
    subscription: {
      type: Object,
      notify: true
    },
    showPayment: {
      type: Boolean,
      default: false
    },
    editablePayment: {
      type: Boolean,
      default: false
    }
  },
  isTranslation: function (title) {
    return title.original.language !== 'fr'
  },
  _translate: function (string) {
    return window.__(string)
  },
  _getDisabledClass: function (item) {
    return item.active ? 'v-spaced width-100-percent active' : 'v-spaced width-100-percent disabled'
  },
  _anyPending: function () {
    return this.subscription.pending_grantees.length > 0
  },
  _deny: function (e) {
    const button = dom(e).localTarget
    this.dispatchEvent(new CustomEvent('deny', { detail: { subscription_id: this.subscription.id, grantee_id: button.dataId } }))
  },
  _accept: function (e) {
    const button = dom(e).localTarget
    this.dispatchEvent(new CustomEvent('accept', { detail: { subscription_id: this.subscription.id, grantee_id: button.dataId } }))
  },
  _cancel: function () {
    this.dispatchEvent(new CustomEvent('cancel', { detail: { subscription_id: this.subscription.id } }))
  },
  _ajaxResponse: function (e) {
  },
  _preventSelfDelete: function (id) {
    const isSelf = (id == this.subscription.possessable.profile_id)
    return isSelf
  },
  _formatDate: function (date) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    if (typeof date === 'number') {
    const d = new Date(date * 1000)
    return (d).toLocaleDateString('fr-FR', options)
    }
    const timestamp = Date.parse(date)
    if (typeof timestamp !== 'number') {
      return date
    }
    const d = new Date(timestamp)
    return (d).toLocaleDateString('fr-FR', options)
  }
})
